import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TvScriptModule } from '@tv/shared/tv-shared-tv-script/tv-script.module';
import { TV_ICON_PATH_TOKEN } from '@tv/tv-icon/tv-icon/tv-icon-pass.token';
import { AppTranslateModule } from '../../commons/app-translate.module';
import { CommonComponentsModule } from '../../commons/components/common-components.module';
import { GlobalErrorHandler } from '../../commons/interceptors/global-error-handler';
import { Interceptor } from '../../commons/interceptors/interceptor';
import { CommonServicesModule } from '../../commons/services/common-services.module';
import { LanguageService } from '../../commons/services/languages.service';
import { LocalStorageService } from '../../commons/stores/local-storage.service';
import { StoreService } from '../../commons/stores/store.service';
import { AppRoutingModule } from './app-routing.module';
import { AboutTrueViewComponent } from './components/about-true-view/about-true-view.component';
import { AppComponent } from './components/app/app.component';
import { CustomCssDirective } from './directives/custom-css.directive';
import { AppService } from './services/app.service';
import { initServiceFactory } from './services/init-service-factory';
import { InitService } from './services/init.service';
import { languageServiceFactory } from './services/language-service-factory';
const imports = [
  BrowserModule,
  BrowserAnimationsModule,
  CommonServicesModule,
  CommonComponentsModule,
  AppRoutingModule,
  FormsModule,
  AppTranslateModule,
  TvScriptModule,
];

@NgModule({
  declarations: [AppComponent, CustomCssDirective, AboutTrueViewComponent],
  imports: imports,
  providers: [
    StoreService,
    LocalStorageService,
    AppService,
    InitService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = initServiceFactory(inject(InitService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = languageServiceFactory(inject(LanguageService));
      return initializerFn();
    }),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: TV_ICON_PATH_TOKEN,
      useValue: './assets/images',
    },
  ],
  exports: [AppTranslateModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
